import { listPatients } from "pages/dashboard/patients/patients.hooks";
import { useMemo } from "react";

function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}

export const useFullSearch = (searchValue, data) =>
    useMemo(() => {
        if (!searchValue) return data;
        // const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
        // return data.filter((row) => Object.keys(row).some((field) => searchRegex.test(row[field])));
        const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
        return data.filter((row) => {
            const rowValues = Object.values(row).join(" ");
            return searchRegex.test(rowValues);
        });
    }, [searchValue, data]);

export const useSearchByKeys = (searchValue, data, keys) =>
    useMemo(() => {
        if (!searchValue) return data;
        const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
        return data.filter((row) => keys.some((key) => searchRegex.test(row[key].toString())));
    }, [searchValue, data, keys]);

export const useFullPatientsSearch = (searchValue, data, paginationModel, setFilteredData) =>
    useMemo(() => {
        if (searchValue === "") return data.patients;

        async function fetchData() {
            const response = await listPatients({
                limit: paginationModel.pageSize,
                keyword: searchValue,
                offset: paginationModel.page * paginationModel.pageSize,
            });
            // console.log('useFullPatientsSearch',  response.data.patients);
            setFilteredData(response.data.patients);
            // return response.data.patients;
        }
        return fetchData();
    }, [searchValue, data, paginationModel, setFilteredData]);

export const useTagsToFilter = (selectedTags, data) =>
    useMemo(() => {
        if (selectedTags.length <= 0) return data;

        return data.filter((row) => selectedTags.every((tag) => JSON.parse(row.tags).includes(tag)));
    }, [selectedTags, data]);

export const useFilterByMultipleValuesOfSingleKey = (selectedValues, data, key) =>
    useMemo(() => {
        if (selectedValues.length <= 0) return data;
        return data.filter((row) => selectedValues.includes(row[key]));
    }, [selectedValues, data, key]);
